import fetcher from "../../../../helpers/fetcher";

export async function ReqImportH7S2SXMLs(
  page,
  office_id,
  debouncedSearchTerm = ""
) {
  let path = `/import-declarations/create-h7/s2s/total?office_id=${office_id}&page=${page}&search=${debouncedSearchTerm}`;

  let request = await fetcher(path, "GET");

  let content = request.json();

  return content;
}

export async function CreateImportH7S2SDeclaration(office_id, body) {
  let path = `/import-declarations/create-h7/s2s?office_id=${office_id}`;

  let request = await fetcher(path, "POST", body, true, true);

  let content = request.json();

  return content;
}

export async function DeleteS2SH7ImportDeclaration(id, office_id) {
  let path = `/import-declarations/create-h7/s2s/${id}?office_id=${office_id}`;

  let request = await fetcher(path, "DELETE");

  let content = request.json();

  return content;
}

export async function CreateCC446DeclarationH7(
  office_id,
  body,
  declaration_id
) {
  let path = `/import-declarations/upload-h7/s2s/CC446?office_id=${office_id}&declaration_id=${declaration_id}`;

  let request = await fetcher(path, "POST", body, true, true);

  let content = request.json();

  return content;
}

export async function CreateCC414DeclarationH7(
  office_id,
  body,
  declaration_id
) {
  let path = `/import-declarations/upload-h7/s2s/CC414?office_id=${office_id}&declaration_id=${declaration_id}`;

  let request = await fetcher(path, "POST", body, true, true);

  let content = request.json();

  return content;
}

export async function CreateCC504DeclarationH7(
  office_id,
  body,
  declaration_id
) {
  let path = `/import-declarations/upload-h7/s2s/CC504?office_id=${office_id}&declaration_id=${declaration_id}`;

  let request = await fetcher(path, "POST", body, true, true);

  let content = request.json();

  return content;
}

export async function CreateCC413DeclarationH7(
  office_id,
  body,
  declaration_id
) {
  let path = `/import-declarations/upload-h7/s2s/CC413?office_id=${office_id}&declaration_id=${declaration_id}`;

  let request = await fetcher(path, "POST", body, true, true);

  let content = request.json();

  return content;
}

export async function CreateCC503DeclarationH7(
  office_id,
  body,
  declaration_id
) {
  let path = `/import-declarations/upload-h7/s2s/CC503?office_id=${office_id}&declaration_id=${declaration_id}`;

  let request = await fetcher(path, "POST", body, true, true);

  let content = request.json();

  return content;
}

export async function GetImportH7S2SDeclarationInfo(office_id, declaration_id) {
  let path = `/import-declarations/create-h7/s2s/info?office_id=${office_id}&declaration_id=${declaration_id}`;

  let request = await fetcher(path, "GET");

  let content = request.json();

  return content;
}

export async function GetImportH7S2SDeclarationInfoForCC413(
  office_id,
  declaration_id
) {
  let path = `/import-declarations/create-h7/s2s/info-cc413?office_id=${office_id}&declaration_id=${declaration_id}`;

  let request = await fetcher(path, "GET");

  let content = request.json();

  return content;
}

export async function GetImportH7S2SDeclarationInfoForCC446(
  office_id,
  declaration_id
) {
  let path = `/import-declarations/create-h7/s2s/info-cc446?office_id=${office_id}&declaration_id=${declaration_id}`;

  let request = await fetcher(path, "GET");

  let content = request.json();

  return content;
}

export async function CreateCC417DeclarationH7(
  office_id,
  body,
  declaration_id
) {
  let path = `/import-declarations/upload-h7/s2s/CC417?office_id=${office_id}&declaration_id=${declaration_id}`;

  let request = await fetcher(path, "POST", body, true, true);

  let content = request.json();

  return content;
}

// ===== Scenarii de test H7 (generare automata CC415, trasabilitate) =====

// Catalogul celor 14 scenarii de test H7.
export async function ListH7Scenarios() {
  let path = `/import-declarations/create-h7/s2s/scenarios`;

  let request = await fetcher(path, "GET");

  let content = request.json();

  return content;
}

// Genereaza si trimite automat un CC415 pentru un scenariu. body = identificatori
// optionali ({ eori, importer_id, declarant_id }); daca lipsesc, se folosesc cei
// din profilul clientului.
export async function GenerateCC415ForScenario(scenario_code, office_id, body) {
  let path = `/import-declarations/create-h7/s2s/scenarios/${scenario_code}/generate?office_id=${office_id}`;

  let request = await fetcher(path, "POST", JSON.stringify(body || {}));

  let content = request.json();

  return content;
}

// Identificatorii S2S salvati pe client (pentru pre-completarea formularului).
export async function GetOfficeS2SProfile(office_id) {
  let path = `/import-declarations/create-h7/s2s/profile?office_id=${office_id}`;

  let request = await fetcher(path, "GET");

  let content = request.json();

  return content;
}
